import { ListDashes } from "@phosphor-icons/react";
import { Button } from "@replicate/ui";
import type { Prediction } from "../../types";
import { route } from "../../urls";

export function ViewPrediction({
  prediction,
}: {
  prediction: Prediction;
}) {
  if (!prediction.id) {
    return null;
  }

  return (
    <Button
      variant="outlined"
      startIcon={<ListDashes size={16} />}
      render={
        // biome-ignore lint/a11y/useAnchorContent: handled by ariakit
        <a
          href={route("prediction_detail", { prediction_uuid: prediction.id })}
        />
      }
    >
      <span>View full prediction</span>
    </Button>
  );
}
